module.exports = __webpack_public_path__ + "img/navigation.56b6ccd3.png";